// Shared option lists & helpers for the wholesale Quote Wizard and Admin
// Quotes dashboard — kept in one place so labels stay consistent with the
// backend's quote_models.py (QUANTITY_TIERS, CURRENCIES, QUOTE_STATUSES).
import { TIRE_CATEGORIES } from './tireSizes';

export const TIRE_TYPES = ['Passenger Car', 'SUV / Light Truck', 'Performance', 'Commercial Truck'];

export const TIRE_GRADES = ['Grade A Premium', 'Grade B Standard', 'Grade C Commercial / Export'];

export const QUANTITY_TIERS = [
  { value: '800', label: '800', sub: '20ft Container' },
  { value: '1600', label: '1,600', sub: '40ft Container' },
  { value: '2400', label: '2,400', sub: '40ft High-Cube' },
  { value: 'custom', label: 'Custom', sub: 'Enter amount' },
];

export const SHIPPING_TERMS = ['FOB', 'CIF', 'CFR', 'EXW', 'DDP'];

export const CURRENCIES = ['USD', 'EUR'];

export const QUOTE_STATUSES = [
  'Received', 'Under Review', 'Compliance Hold', 'Quoted',
  'Accepted', 'Rejected', 'Invoiced', 'Fulfilled', 'Closed',
];

export const FULFILLMENT_STATUSES = ['Pending', 'In Production', 'Shipped', 'Delivered'];

// Flat list of every catalog size, grouped by category label, for the
// wizard's size picker.
export const SIZE_GROUPS = TIRE_CATEGORIES.map((cat) => ({ label: cat.label, sizes: cat.sizes }));

export const displayQuantity = (quote) =>
  quote.quantity_tier === 'custom' ? quote.custom_quantity : Number(quote.quantity_tier);

// Mirrors compute_quote_totals() in backend/quote_models.py — used only for
// instant client-side preview while an admin edits pricing; the backend's
// response after Save is always the source of truth that gets persisted.
export const computeTotalsPreview = (quote, pricing) => {
  const quantity = quote.quantity_tier === 'custom' ? Number(quote.custom_quantity || 0) : Number(quote.quantity_tier || 0);
  const unitPrice = Number(pricing.unit_price || 0);
  const subtotal = Math.round(unitPrice * quantity * 100) / 100;
  const freight = pricing.freight_included_in_unit_price ? 0 : Number(pricing.freight_cost || 0);
  const insurance = Number(pricing.insurance_cost || 0);
  const total = Math.round((subtotal + freight + insurance) * 100) / 100;
  return { quantity, unitPrice, subtotal, freight, insurance, total, currency: pricing.currency || 'USD' };
};

export const CURRENCY_SYMBOL = { USD: '$', EUR: '\u20ac' };

export const fmtMoney = (amount, currency = 'USD') =>
  `${CURRENCY_SYMBOL[currency] || currency + ' '}${Number(amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
